<template>
  <div class="sidebar">
    <div class="brand">POS</div>
    <div
      class="category-item"
      :class="{ active: activeCategory === '' }"
      @click="handleCategoryClick('')"
    >
      全 部
    </div>
    <div
      v-for="category in productCategorys"
      :key="category.categoryId"
      class="category-item"
      :class="{ active: activeCategory === category.categoryId }"
      @click="handleCategoryClick(category.categoryId)"
    >
      {{ category.categoryName }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MealCategorySidebar',
  props: {
    activeCategory: {
      type: String,
      default: ''
    },
    productCategorys: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleCategoryClick(categoryId) {
      this.$emit('category-change', categoryId)
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 110px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.02);
  z-index: 10;
}

.brand {
  font-size: 18px;
  font-weight: 900;
  color: #FF6B6B;
  text-align: center;
  margin-bottom: 30px;
  letter-spacing: 1px;
}

.category-item {
  padding: 16px 5px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: #636E72;
  cursor: pointer;
  border-radius: 12px;
  margin-bottom: 8px;
  transition: 0.2s;
}

.category-item.active {
  background: #FF6B6B;
  color: white;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

.category-item:hover {
  background: #f0f0f0;
}

.category-item.active:hover {
  background: #FF5252;
}
</style>

